import Backbone from 'backbone';

export default Backbone.View.extend({
  tagName: 'style',

  initialize(o = {}) {
    this.config = o.config || {};
    const model = this.model;
    const toTrack = 'change:style change:state change:mediaText';
    this.listenTo(model, toTrack, this.render);
    this.listenTo(model, 'destroy remove', this.remove);
    this.listenTo(model.get('selectors'), 'change', this.render);
  },

  render() {
    const model = this.model;
    let important = model.get('important');
    if (model.get('isStateRecording')) {
      important = 1;
      let selModel = editor.getSelected();
      let states = {};
      states[model.get('recordingStateName')] = model.get('style');
      selModel.set('recordedState', states);
    }
    this.el.innerHTML = this.model.toCSS({ important });
    return this;
  }
});
